import React, { FC, useMemo } from 'react'
import { Button, Table, Upload, Tooltip, notification } from 'antd'
import { YhBox } from '@/components/YhBox'
import { globalPrompt } from '@/components/message'
import { ColumnsType } from 'antd/es/table'
import { DetailType } from '@/types/ScmEnums'
import { useStockCheckDetailModel } from './stockCheckDetailsModel'
import { IDetailList } from '../../stockCheckType'
import { EditableCell, EditableRow } from '@/components/YHEditTable/editTable'
import { importPropsConfig } from '@/utils/importFile'
import { ITopType } from '@/types/ScmTypes'
import { formatNum } from '@/utils/utils'
import { YhAuth } from '@/components/auth/YhAuth'
import { ResourceAuthEnum } from '@/types/VrmResoureAuthEnum'
import { DictCodeEnmu } from '@/types/VrmSaDictEnums'
import YhTootip from '@/components/YhTootip'
import useGlobalModel from '@/model/globalModel'
import { ExclamationCircleFilled, ExclamationCircleOutlined, ExclamationOutlined } from '@ant-design/icons'
import { roleColumnModel } from "@/utils/roleColumn";
export const TableBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const {
        setAddModalVisible,
        detailEditForm: { status },
        detailDataSource,
        detaiAddDataRowKeys,
        onExport,
        detailEditForm,
        detailAddForm,
        modelScreenMethod,
        setProfitAndLoss,
        detailLookList,
        detailAddList,
        detailDataRowKeys,
        setDetailAddList,
        setDetailDataRow,
        setDetailDataSource,
        setDetailDataRowKeys,
        detailDetailList,
        setDetaiAddDataRowKeys,
        setDetaiAddDataRow,
    } = useStockCheckDetailModel()
    const { user: { roles }, shopAndOrg: { shopId }, setLoadingInfo, } = useGlobalModel()
    const { getRoleColumns } = roleColumnModel();
    const importCallback = async (list: any) => {
        if (!list) return
        let newList: any = []
        let errorList: any = []
        list.map(async (item: any) => {
            if (item.status) {
                newList.push(...item.list)
            }
            else {
                errorList.push(item.msg)
            }
        })
        if (mode === 'add') {
            const { repetition, newDetailData } = await modelScreenMethod(newList, detailAddList)
            setDetailAddList([...detailAddList, ...newDetailData])
            repetition.length !== 0 && globalPrompt('message', { text: `物料名称：${repetition.join(',')}，重复的将不在添加。`, type: 'warning' })
        } else if (mode === 'edit') {
            const { repetition, newDetailData } = await modelScreenMethod(newList, detailDataSource)
            setDetailDataSource([...detailDataSource, ...newDetailData])
            repetition.length !== 0 && globalPrompt('message', { text: `物料名称：${repetition.join(',')}，重复的将不在添加。`, type: 'warning' })
        }
        console.log(errorList)
        setLoadingInfo({ loadingVisible: false })
        notification.warning({ message: '提醒', description: errorList, duration: 30000 })
    }
    const addMaterial = () => {
        IFormRef.current?.validateFields().then(async (res) => {
            setAddModalVisible(true)
        })
    }
    // 删除(做限制)
    const onRemove = (mode: string) => {
        // if(mode === 'edit' && detailDataSource.length < 1){
        //     globalPrompt("message", { text: "请至少保留一条数据", type: "error" });
        //     return
        // }
        detailDetailList(mode)
    }
    const action =
        mode === DetailType.look ? (
            <></>
        ) : (
            <>
                <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_ADD_M}>
                    <Button className="mr-5" type="primary" shape="round" onClick={addMaterial}>
                        新增配件
                    </Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_EDL_M}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={() => {
                            onRemove(mode)
                        }}
                    >
                        删除
                    </Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_IM}>
                    <Upload
                        showUploadList={false}
                        className="mr-10 ml-10"
                        {...importPropsConfig(`/zzw-vrm/stock/check/details/import`, importCallback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中" }), {
                            shopId,
                            warehouseCode: mode === DetailType.add ? detailAddForm.warehouseCode : detailEditForm.warehouseCode,
                        })}
                    >
                        <Button
                            className="mr-5"
                            type="primary"
                            shape="round"
                            disabled={!(mode === DetailType.add ? detailAddForm.warehouseCode : detailEditForm.warehouseCode)}
                        >
                            导入
                        </Button>
                    </Upload>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_ED_EX}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={() => {
                            onExport()
                        }}
                    >
                        下载模板
                    </Button>
                </YhAuth>
            </>
        )
    const defaultColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: string, r: any, i: number) => <>{i + 1}</>,
        },
        {
            title: '商品编码',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '商品名称',
            dataIndex: 'materialName',
            width: 120,
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '仓库',
            dataIndex: 'warehouseName',
            width: 120,
        },
        {
            title: '货位',
            dataIndex: 'shelfCode',
            width: 120,
        },
        // {
        //     title: '最新采购价格',
        //     dataIndex: 'averagePurchasePrice',
        //     width: 140,
        // },
        {
            title: '档案进价',
            dataIndex: 'purchasePrice',
            width: 120,
        },
        {
            title: '系统库存',
            dataIndex: 'inventoryNum',
            width: 120,
        },
        {
            title: '实际库存',
            dataIndex: 'realNum',
            editable: mode != 'look' ? true : false,
            rules: [
                { required: true, message: '该项为必填' },
                { transform: (value: any) => Number(value), pattern: /^[0-9]+(\.\d+)?$/, message: '请输入正整数' },
            ],
            width: 120,
        },
        {
            title: '盘点结果',
            dataIndex: 'result',
            width: 120,
        },
        {
            title: '差异量',
            dataIndex: 'differenceNum',
            width: 120,
        },
        {
            title: (<Tooltip title="差异金额=最新采购价格 X 差异量">
                <span>差异金额<ExclamationCircleFilled style={{ color: '#ff8b00', marginLeft: '5px' }} /></span>
            </Tooltip>),
            dataIndex: 'differenceAmount',
            width: 120,
        },
        {
            title: '报废数量',
            dataIndex: 'scrapNum',
            editable: mode != 'look' ? true : false,
            width: 120,
        },
        {
            title: '报废金额',
            dataIndex: 'scrapAmount',
            width: 120,
        },
        {
            title: '差异原因',
            width: 160,
            dataIndex: 'note',
            editable: mode != 'look' ? true : false,
        },
        {
            title: '报废原因',
            width: 160,
            dataIndex: 'scrapReason',
            editable: mode != 'look' ? true : false,
        },
    ]

    const typeList = {
        add: detailAddList,
        edit: detailDataSource,
        look: detailLookList,
    }

    const newSelectMaterialColums = () =>
        defaultColumns.map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    suffix: col.suffix,
                    editable: status === DictCodeEnmu.STOCKTAKING_COMPLETE ? false : col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleMaterialSave,
                }),
            }
        })

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockCheck", "roleCodes": roles };
        return getRoleColumns("stockCheck", "明细", newSelectMaterialColums(), params);
    }, [roles, typeList[mode], defaultColumns]);
    const handleMaterialSave = (row: IDetailList) => {
        let { realNum, result, differenceAmount, differenceNum, inventoryNum, latestPurPrice, averagePurchasePrice, scrapNum, scrapAmount } = row
        scrapNum = +formatNum(scrapNum)
        averagePurchasePrice = +formatNum(averagePurchasePrice)
        let newRow = {
            ...row,
            differenceNum: Number(realNum) - Number(inventoryNum),
            result: setProfitAndLoss(Number(realNum) - Number(inventoryNum)),
            differenceAmount: +((Number(realNum) - Number(inventoryNum)) * Number(averagePurchasePrice)).toFixed(2),
            scrapAmount: +formatNum(scrapNum * averagePurchasePrice),
        }
        let newData = mode === 'edit' ? detailDataSource : detailAddList
        const index = newData.findIndex((item) => row.detailsId === item.detailsId)
        const item = newData[index]
        newData.splice(index, 1, { ...item, ...newRow })
        mode === 'edit' ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
    }

    const setTypeDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeDetailDataRow = async (selectedRows: IDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetaiAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailDataRow(selectedRows)
        }
    }
    return (
        <YhBox title="盘点明细" rightChildren={action} style={{ marginBottom: '75px' }}>
            <Table
                bordered
                rowClassName="editable-row yh-edit-table-tr"
                rowKey={(record) => record.detailsId as string}
                rowSelection={
                    mode === DetailType.look
                        ? undefined
                        : {
                            selectedRowKeys: mode === DetailType.add ? detaiAddDataRowKeys : detailDataRowKeys, //记录选中
                            onChange: (selectedRowKeys: React.Key[], selectedRows: IDetailList[]) => {
                                setTypeDetailDataRowKeysAndRow(selectedRowKeys, mode)
                                setTypeDetailDataRow(selectedRows, mode)
                            },
                            onSelectAll: (selected, selectedRows, changeRows) => {
                                setTypeDetailDataRow(selectedRows, mode)
                            },
                        }
                }
                columns={roleColumns}
                dataSource={typeList[mode]}
                pagination={false}
                onRow={(record) => ({
                    onClick: () => { },
                })}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                scroll={{ x: 'max-content', y: 450 }}
            />
        </YhBox>
    )
}
